export default __webpack_public_path__ + "static/media/baila1.58162d55.png";